import React from 'react';
import QueryDetails from './querydetails';
import ComplaintTable from './complainttable';
import './querymanagement.css';

const ShowTablePage = () => {
  return (
    <main className="ca-query-management-page">
      <QueryDetails />
      <ComplaintTable />
    </main>
  );
};

export default ShowTablePage;